export default __webpack_public_path__ + "static/media/1026-00.2b27ac13.jpg";